module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAVZJREFUOE+tlL1OAlEQhc/s4hNoo6waY0OnhQ9ga+IDqPEHBWPsLEnQhAKjr2CUiAakkILSkkfQB7BAd6k0sWf3HnNBkl2yy0LkdpPMfHPuuTNXMKEjE+IgFvSwn5zWzQ4ene9hTSNBhXUk5i0rD+K8CxAUP237stCEGwYMBZV2kytCKUNkNVBEvlKYzlSct0FYAORXISKJsM4k3TB1AVBpJ5kWw7jvA7pFkLtezKwfTqUOM09OuZ8bCSJos9PZMExzWScrz3s3ElPPEEl1saOCADYFeCHkuuc1c6CkKEiDrHeUOj2ptb9iFYWBFOkqoHVcdepDzfZ7pK8GcJMel3RRttZujDxHUWa7yrvwXyN2jvTzL1jWFYmzgef/AVTuw3ZK4w3k1uyamOZtyEBWjqr2Xqwif4JWt2hZefW3Ioag2Bp3RfzAm+25GR2P5dF/vpTYb2RU+C+0yaMTxXfkQAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SearchPage/all.png
// module id = OIF/
// module chunks = 1